import React from 'react';
import moveGoogleMapsToNode from 'view/pages/assignment-list/google-maps/move-google-maps-to-node';

export default function GoogleMapsRef() {
  return <div ref={moveGoogleMapsToNode} />;
}
